import { render, staticRenderFns } from "./HostingSearch.vue?vue&type=template&id=28b905be&scoped=true&"
import script from "./HostingSearch.vue?vue&type=script&lang=js&"
export * from "./HostingSearch.vue?vue&type=script&lang=js&"
import style0 from "./HostingSearch.vue?vue&type=style&index=0&id=28b905be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b905be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28b905be')) {
      api.createRecord('28b905be', component.options)
    } else {
      api.reload('28b905be', component.options)
    }
    module.hot.accept("./HostingSearch.vue?vue&type=template&id=28b905be&scoped=true&", function () {
      api.rerender('28b905be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Services/HostingSearch.vue"
export default component.exports